import { FormLabel as FormLabelMUI, FormLabelProps } from '@mui/material';
import { grey } from '@mui/material/colors';

export const FormLabel = (props: FormLabelProps) => (
  <FormLabelMUI
    sx={(theme) => ({
      display: 'flex',
      alignItems: 'center',
      color: grey[800],
      fontSize: theme.typography.subtitle2.fontSize,
      lineHeight: theme.typography.subtitle2.lineHeight,
      fontWeight: 500,
      px: 0.5,
      mb: 1,
    })}
    {...props}
  />
);
